
import React, {useState,useEffect} from 'react';
// import Address from './Address';
import './Cart.css';
import PaymentSummary from './PaymentSummary';
import axios from 'axios';
import ReactLoading from 'react-loading';
// import base_url from '../utils/getlink';
// import CartCard from './CartCard';

// const getCart = ()=>{
//   return axios({
//     method:'get',
//     url:`${base_url}/users/cart`,
//     headers:{
//       'authorization':`Bearer ${localStorage.getItem('token')}`
//     }
//   })
// }




const Cart = () => {
// console.log('heleo')
// const [cartItems,setCartItems]=useState([]);
//   useEffect(()=>{
//     getCart().then((res)=>{
//       setCartItems(res.data.data);
//       console.log(res.data.data);
//     }).catch((e)=>{
//       console.log('error',e);
//     })
//   },[setCartItems]);
//   useEffect(()=>{
//     console.log(cartItems);
//   },[cartItems])
  const [cart, setCart] = useState();
  const [itemQty,setItemQty] = useState(0);
  const [total,setTotal] = useState(0);
  const [itemTotal,setItemTotal] = useState(0)
  const [plusMembership,setPlusMemberShip] = useState(0)

  // const [remove,setRemove] = useState(0);
  const [isDataReady,setIsDataReady] = useState(false);
  const Example = ({ type, color }) => (
    <ReactLoading type={type} color={color} height={'20%'} width={'20%'} />
);
  const getPaymentDetails = ()=>{
    axios.get(`http://localhost:5003/localdata`)
  .then((res) => {
    console.log(`data refreshed...${res.data})`)

    setCart({"Itembaseprice":250,
    "Itemqty": 2,
    "userid":"639efe8cb411030e69660ee0",
    "Itemdiscount":10,
    "MembershipDiscount":10,
    "TaxesandFee":10,
    "PlusMembership":10});
    // console.log(cart)
    let t = (250*2)+10+10-(10+10);
    // console.log(t)
    setTotal(t);
    setItemTotal(250*2);
    setItemQty(2);
    setPlusMemberShip(10);

    setTimeout(()=>{
      setIsDataReady(false)
    },1000)
    
    // console.log(cart.itemQty)
    // setItemQty(res.data.data.Itemqty);
  })
  }

  useEffect(() => {
    getPaymentDetails();
  }, [])

  

  const updateQty = async (qty)=>{
    setIsDataReady(true)
    // console.log(cart)
    let obj = {...cart};
    if(qty === 'add'){
      if(cart.Itemqty<3){
        
        console.log('add calling')
        let it = parseInt(cart.Itemqty)+1;
        obj.Itemqty=it;
        setItemQty(it);
        setTotal(cart.Itembaseprice*it);
  
        setCart(obj);
      }
    }
    if(qty==='remove_member'){
      // obj = {PlusMembership:0};
      obj.PlusMembership=0;
      setPlusMemberShip(0);
      setCart(obj);
    }
    if(qty === 'add_member'){
      // obj = {PlusMembership:10};
      obj.plusMembership=10;
      setPlusMemberShip(10);
      setCart(obj);
    }
    if(qty=== 'sub'){
      if(cart.Itemqty>1){
        let it = parseInt(cart.Itemqty)-1;
        obj.Itemqty=it;
        setTotal(cart.Itembaseprice*it);
        setItemQty(it);
        setCart(obj);
      }
     
      // obj = {Itemqty:it};
    }

    
    // console.log(obj)
    // await axios.patch(`http://localhost:5003/cart/update/${cart._id}`,obj);
    // setItemQty(cart.Itemqty);

    setIsDataReady(false)
  }
  
  if(isDataReady){
    return <div style={{margin:'auto',textAlign:'center', justifyContent:'center',alignItem:'center',display:'flex'}}><Example type={'bubbles'} color="teal"/></div>
  }
  return (
    <>
     <div className='heading'>⬅ Summary</div>
     
     <hr className='summary' />
    <div className='cartpage'>
      <div className='cartpart'>
        <div><h4>You're saving total ₹825 on this order!</h4></div>
        <div><h5>Including ₹75 with plus</h5></div>
        <hr className='hr1' />
        <div className='cartdiv1'>Haircut + Beared Grooming + Head Massage<div className='cartdiv2'>
          <div><button className='cartbutton' onClick={()=>updateQty('sub')}> - </button></div>
          <div className='cartcount'> {itemQty} </div>
          <div><button className='cartbutton' onClick={()=>updateQty('add')}> + </button></div>
        </div>
        <div>₹{total}</div>
        </div>
        <hr className='hr2' />
        <div className='cartdiv3'>
          <ul><li>Men;s Haircut x1</li></ul>
          <ul><li>10 min Head Massage x1</li></ul>
          <ul><li>Beard Shape & Style x1</li></ul>
        </div>
        {/* {cartItems.length>0&&cartItems.map((el)=>{
          return <CartCard key={el._id} data={el} />
        })}
         */}
        <div className='cartdiv4'>Edit package</div>

        <div className='cartdiv1'>Plus Membership<div className='cartdiv2'>
          

        
        {plusMembership && <button onClick={()=>updateQty('remove_member')} className='cartb'>Remove</button>}
        {!plusMembership && <button onClick={()=>updateQty('add_member')} className='cartb'>Add</button>}
        
          
          
        </div>
        <div>₹{plusMembership}</div>
        
        </div>
        <hr className='hr1' />
        <div className='cartdivtogether'>Frequently added together</div>
  
      </div>
        
        {cart && <PaymentSummary cart={cart} total={total} itemTotal={itemTotal} plusMembership={plusMembership}/>} 
    </div>
    
    </>
    
  )
}

export default Cart
